'use client';

import { FormattedMessage } from '@flipster/i18n';
import { useOverlay } from '@flipster/overlay';
import { IconButton } from '@flipster/react/design-system/icon-button';
import { Modal } from '@flipster/react/design-system/modal';
import QuestionCircleIcon from '@flipster/react/icon/generated/QuestionCircleIcon';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';

export const EarningsFluctuationTooltip = () => {
  const overlay = useOverlay();
  return (
    <div
      className={hstack({
        tabletDown: { justifyContent: 'start', mt: 8 },
        tablet: { justifyContent: 'end', mt: 10 },
      })}
    >
      <div
        role='button'
        className={hstack({ cursor: 'pointer' })}
        onClick={() =>
          overlay.open(({ isOpen, close, unmount }) => (
            <Modal.Root isOpen={isOpen} onClose={close} onExit={unmount} mode='bottomSheet'>
              <Modal.Header>
                <Modal.Title label={<FormattedMessage id='Earn.r260212.Why_do_earnings_fluctuate_question' />} />
              </Modal.Header>
              <Modal.Content>
                <ul className={css({ list: 'disc', color: 'content.default.level-3' })}>
                  <li>
                    <FormattedMessage id='Earn.r260212.Why_do_earnings_fluctuate_question_description_1' />
                  </li>
                  <li>
                    <FormattedMessage id='Earn.r260212.Why_do_earnings_fluctuate_question_description_2' />
                  </li>
                  <li>
                    <FormattedMessage id='Earn.r260212.Why_do_earnings_fluctuate_question_description_3' />
                  </li>
                  <li>
                    <FormattedMessage id='Earn.r260212.Why_do_earnings_fluctuate_question_description_4' />
                  </li>
                </ul>
              </Modal.Content>
            </Modal.Root>
          ))
        }
      >
        <p
          className={css({
            textStyle: 'Text/M/Monospace/Regular',
            color: 'content.default.level-3',
          })}
        >
          <FormattedMessage id='Earn.r260212.Why_do_earnings_fluctuate_question' />
        </p>
        <IconButton
          icon={<QuestionCircleIcon color={token('colors.content.default.level-1')} />}
          hierarchy='quaternary'
          size='small'
        />
      </div>
    </div>
  );
};
